<button (click)="confirmLogout()" class="vwui-btn">
    <app-icon class="is-primary logout-img" iconName="logout"></app-icon>
</button>
